import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { CLIENT_SOFTWARE } from '../constant/actionTypes';

const clientSoftwareChartDataApiEndPoint = constants.ADMIN_URL;

const getClientSoftwareChartData = () => (dispatch) => httpservice()
  .get(`${clientSoftwareChartDataApiEndPoint}${constants.API.CLIENT_SOFTWARE_CHART}`)
  .then((clientSoftwareChartData) => {
    dispatch({
      payload: clientSoftwareChartData.data,
      type: CLIENT_SOFTWARE.GET.SUCCESS,
    });
  })
  .catch((clientSoftwareChartError) => {
    dispatch({
      payload: clientSoftwareChartError,
      type: CLIENT_SOFTWARE.GET.ERROR,
    });
  });

export default getClientSoftwareChartData;
